var OfferValue;
(function (OfferValue) {
    OfferValue["None"] = "none";
    OfferValue["SemiAnnual"] = "semiannual";
    OfferValue["Subscription"] = "subscription";
    OfferValue["Trial"] = "trial";
})(OfferValue || (OfferValue = {}));
export default OfferValue;
